import React from 'react';
import AbcLogo from '../logos/AbcLogo';
import DisneyLogo from '../logos/DisneyLogo';
import EspnLogo from '../logos/EspnLogo';
import MarvelLogo from '../logos/MarvelLogo';
import NatGeoLogo from '../logos/NatGeoLogo';
import PixarLogo from '../logos/PixarLogo';
import LucasLogo from '../logos/LucasLogo';
import FxLogo from '../logos/FxLogo';
import TranslatedComponent from '../../utils/TranslatedComponent';
import {determineLegalCountry, isEmeaCountry} from '../../utils/helpers';
import EmeaFooter from './EmeaFooter';
import DefaultFooter from './DefaultFooter';

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const country = determineLegalCountry();

    if (country !== 'US') {
      document.cookie = 'country=;expires=-1;'
    };
  }

  render() {
    var classNames = ['footerContainer'];

    classNames.push((this.props.hasChanges && this.props.userHasInteracted) ? 'showSave' : 'hideSave');

    return (
      <footer className={classNames.join(' ')}>
        <div id='footerLogos' className='logosBarContainer'>
          <DisneyLogo/>
          <PixarLogo/>
          <LucasLogo/>
          <MarvelLogo/>
          <NatGeoLogo/>
          <AbcLogo/>
          <EspnLogo/>
          <FxLogo/>
        </div>
        <div className='footerLinksContainer'>
          {!isEmeaCountry() ? (
            // Default footer if country is not in EMEA region
            <DefaultFooter/>) : (
            <EmeaFooter />)}
        </div>
      </footer>
    );
  }
}

TranslatedComponent(Footer);
module.exports = Footer;



// WEBPACK FOOTER //
// ./client/src/components/footer/Footer.jsx